import $ = require("jquery");
import Portal = require("portal-gis");
import Services = require("./services");
import globals = require("../../globals");
import Utils = require("../utils");

interface RowItem {
    data: Portal.MapApplicationElement;
    href: string
}

class AgencyMaps extends Services.BaseService<RowItem> {

    static about = `
property/agencymap proxy service
    `;

    constructor(public api: Services.API) {
        super(api, "property/agencymaps");
        this.idAttribute = "id";
        if (api.stub) this.get = this.getStub;
    }

    private getStub(id: string): JQueryDeferred<RowItem> {
        console.log(`getting stub maplet: ${id}`);
        var d = $.Deferred<RowItem>();
        requirejs(["app/test/data/mapstates"], (config: Portal.GisConfigElements) => {
            let app = config.MapletsConfig.Maplets.filter(app => app.id === id)[0];
            if (!app) throw `missing stub maplet: ${id}`

            console.log(`loading stub maplet: ${id}`);
            app = Utils.deep(app);

            d.resolve({
                data: app,
                href: "stub"
            });
        });
        return d;
    }

    public each() {

        let q = this.api.query ? "?" + $.param(this.api.query) : "";

        return this.auth<Array<RowItem>>(() => $.ajax({
            dataType: "json",
            url: `${this.api.endpoint}/${this.serviceName}?${q}`,
            proxy: false,
            cache: globals.cachebust !== "1"
        }));

    }

    public all(cb?: (item: RowItem) => void) {

        var d = $.Deferred<Array<RowItem>>();

        this.each().done(ids => {
            cb && ids.forEach(item => this.get(item["id"]).done(cb));
            d.resolve(ids);
        });

        return d;
    }

}

export = AgencyMaps;